/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Product_CategoryInputs */

const en_field_product_category = /** @type {(inputs: Field_Product_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product category`)
};

/**
* | output |
* | --- |
* | "Product category" |
*
* @param {Field_Product_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_product_category = /** @type {((inputs?: Field_Product_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Product_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_product_category(inputs)
});